import {useContext} from 'react';

import {UpdateServiceContext} from '../contexts/UpdateService';

export const useUpdateService = () => useContext(UpdateServiceContext);
